var moduleMap = {
	"./app": () => {
		return Promise.all([__webpack_require__.e(0), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(607)]).then(() => (() => ((__webpack_require__(27718)))));
	},
	"./customStyles": () => {
		return __webpack_require__.e(732).then(() => (() => ((__webpack_require__(83732)))));
	},
	"./metadata": () => {
		return __webpack_require__.e(385).then(() => (() => ((__webpack_require__(60385)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});